import * as React from "react";

import { useDebounceCallback } from "@react-hook/debounce";
import { useWindowSize } from "./useWindowSize";

export function useScrollPosition() {
  const [position, setPosition] = React.useState({ x: 0, y: 0 });
  const handleScroll = useDebounceCallback(
    () => {
      setPosition({
        x: window.pageXOffset,
        y: window.pageYOffset,
      });
    },
    100,
    true
  );
  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);
  return position;
}

export function useIsScrolledToBottom() {
  const [isBottomed, setIsBottomed] = React.useState(false);
  const scrollPosition = useScrollPosition();
  const windowSize = useWindowSize();
  React.useEffect(() => {
    setIsBottomed(windowSize.height + scrollPosition.y >= document.body.offsetHeight);
  }, [scrollPosition, windowSize]);
  return isBottomed;
}
